/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün"
            ],
            "singular": [
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün"
            ]
      },
      "hour": {
            "plural": [
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat"
            ],
            "singular": [
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat"
            ]
      },
      "minute": {
            "plural": [
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika"
            ],
            "singular": [
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika"
            ]
      },
      "month": {
            "plural": [
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay"
            ],
            "singular": [
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay"
            ]
      },
      "second": {
            "plural": [
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye"
            ],
            "singular": [
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye"
            ]
      },
      "year": {
            "plural": [
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş"
            ],
            "singular": [
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
